import {connect} from 'react-redux';
import Annotation, {AnnotationProps} from './Annotation';
import Action from '../../redux/Actions';
import {Dispatch} from 'redux';
import ReduxState from '../../types/ReduxState';
import CommentModel from '../../types/CommentModel';
import {QuizState} from '../../globals/Constants';

const mapStateToProps = (state: ReduxState, ownProps: AnnotationContainerProps): Partial<AnnotationProps> => {
   return {
      selectedComment: state.selectedComment || {} as CommentModel,
      player: state.player,
      playTime: state.playTime || 0,
      annotationMode: state.annotationMode,
      mediaDimensions: state.mediaDimensions || null,
      storeAnnotation: ownProps.storeAnnotation,
      hideAnnotation: state.hideAnnotation,
      center: ownProps.center,
      quizState: state.quizState,
      visibleComments: state.visibleComments
   };
};

const mapDispatchToProps = (dispatch: Dispatch<ReduxState>): Partial<AnnotationProps> => {
   return {
      setCanvas: canvas => {
         dispatch(Action.setCanvas(canvas));
      },
      setAnnotationMode: annotationMode => {
         dispatch(Action.setAnnotationMode(annotationMode));
      },
      setQuizState: (quizState: QuizState) => {
         dispatch(Action.setQuizState(quizState));
      }
   };
};

export default connect(mapStateToProps, mapDispatchToProps)(Annotation);

interface AnnotationContainerProps {
   center: boolean;
   storeAnnotation(annotation: string): void;
}
